import { useQuery } from '@tanstack/react-query'
import { KeyRound } from 'lucide-react'
import { listPermissions, listRoles } from '../../../api/admin'
import { QueryBoundary } from '../../../components/common/QueryBoundary'
import { EmptyState } from '../../../components/common/Status'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../../components/ui/tabs'
import { Skeleton } from '../../../components/ui/skeleton'

/** 角色与权限码目录（只读） */
export function RolesSection() {
  const rolesQuery = useQuery({ queryKey: ['v2', 'roles'], queryFn: listRoles, retry: 1 })
  const permsQuery = useQuery({ queryKey: ['v2', 'permissions'], queryFn: listPermissions, retry: 1 })

  return (
    <div className="panel-glass rounded-xl p-4">
      <Tabs defaultValue="roles">
        <TabsList>
          <TabsTrigger value="roles">角色</TabsTrigger>
          <TabsTrigger value="permissions">权限码</TabsTrigger>
        </TabsList>

        <TabsContent value="roles">
          <QueryBoundary
            query={rolesQuery}
            skeleton={<Skeleton className="h-40 rounded-lg" />}
            isEmpty={(items) => items.length === 0}
            empty={{ title: '无角色记录', icon: <KeyRound size={24} /> }}
          >
            {(items) => (
              <table className="w-full text-left">
                <thead className="border-b border-border text-[10px] uppercase tracking-wider text-muted-foreground">
                  <tr>
                    <th className="px-3 py-2 font-medium">代码</th>
                    <th className="px-3 py-2 font-medium">名称</th>
                    <th className="px-3 py-2 font-medium">说明</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border/70">
                  {items.map((r) => (
                    <tr key={r.code} className="text-xs">
                      <td className="px-3 py-2.5 font-mono text-primary">{r.code}</td>
                      <td className="px-3 py-2.5 text-foreground/90">{r.name}</td>
                      <td className="px-3 py-2.5 text-muted-foreground">{r.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </QueryBoundary>
        </TabsContent>

        <TabsContent value="permissions">
          <QueryBoundary
            query={permsQuery}
            skeleton={<Skeleton className="h-40 rounded-lg" />}
            isEmpty={(items) => items.length === 0}
            empty={{ title: '无权限码记录' }}
          >
            {(items) => (
              <table className="w-full text-left">
                <thead className="border-b border-border text-[10px] uppercase tracking-wider text-muted-foreground">
                  <tr>
                    <th className="px-3 py-2 font-medium">权限码</th>
                    <th className="px-3 py-2 font-medium">说明</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border/70">
                  {items.map((p) => (
                    <tr key={p.code} className="text-xs">
                      <td className="px-3 py-2.5 font-mono text-primary">{p.code}</td>
                      <td className="px-3 py-2.5 text-muted-foreground">{p.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </QueryBoundary>
        </TabsContent>
      </Tabs>
      <div className="mt-3 border-t border-border pt-2">
        <EmptyState
          title="目录数据由后端种子迁移维护"
          description="角色/权限码变更请通过数据库迁移（migrations/0001_identity_rbac_audit）管理"
        />
      </div>
    </div>
  )
}
